import React, { useEffect } from 'react';
import { OverlayKind } from '../../game/presentation';

interface CelebrationProps {
  kind: OverlayKind;
  message: string;
  onDone: () => void;
}

const TITLES: Record<Exclude<OverlayKind, null>, string> = {
  solve: 'Solved',
  bankrupt: 'Bankrupt',
  win: 'You win',
};

const Celebration: React.FC<CelebrationProps> = ({ kind, message, onDone }) => {
  useEffect(() => {
    if (!kind) return undefined;
    const timer = window.setTimeout(onDone, kind === 'win' ? 2800 : 1800);
    return () => window.clearTimeout(timer);
  }, [kind, onDone]);

  if (!kind || kind === 'win') {
    return null;
  }

  return (
    <div className="ss-overlay is-center" role="status" aria-live="assertive">
      <div className={`ss-modal ss-cele is-${kind}`}>
        <div className="big">{TITLES[kind]}</div>
        <p className="ss-sub">{message}</p>
      </div>
    </div>
  );
};

export default Celebration;
